import { Button, Form } from 'react-bootstrap';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import spinnerTitle from 'components/others/spinnerTitle';

interface AddVendorFormProps {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    isSubmitting: boolean;
    nameError?: string;
    emailError?: string;
}

const AddVendorForm = ({ handleSubmit, isSubmitting, nameError, emailError }: AddVendorFormProps) => {
    const { t } = useTranslation(['Products', 'common']);
    const refInput = useRef<HTMLInputElement>(null);
    const refEmail = useRef<HTMLInputElement>(null);
    const [showEmail, setShowEmail] = useState(Boolean(emailError));

    useEffect(() => {
        setTimeout(() => {
            refInput.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        if (emailError) setShowEmail(true);
    }, [emailError]);

    useEffect(() => {
        if (!showEmail) return;
        setTimeout(() => {
            refEmail.current?.focus();
        }, 50);
    }, [showEmail]);

    return (
        <Form onSubmit={handleSubmit} className="mx-3 mb-3 p-3 border rounded">
            <Form.Group className="mb-2">
                <label className="form-label text-muted" htmlFor="addVendorName">
                    {t('vendorsEditor.labelName')}
                </label>
                <div className="d-flex gap-2">
                    <Field
                        innerRef={refInput}
                        required
                        id="addVendorName"
                        name="vendorName"
                        className={`form-control ${nameError ? 'is-invalid' : ''}`}
                        placeholder={t('vendorsEditor.placeholderName')}
                    />
                    <Button type="submit" variant="success" disabled={isSubmitting} className="flex-shrink-0">
                        {spinnerTitle(
                            <>
                                <i className="bi bi-plus fs-14"></i>
                                <span className="ms-1">{t('common:buttons.create')}</span>
                            </>,
                            isSubmitting,
                            t('common:buttons.creating'),
                        )}
                    </Button>
                </div>
                {nameError ? <div className="invalid-feedback d-block">{nameError}</div> : null}
            </Form.Group>

            {showEmail ? (
                <Form.Group className="mb-0">
                    <label className="form-label text-muted" htmlFor="addVendorEmail">
                        {t('vendorsEditor.labelEmail')}
                    </label>
                    <Field
                        innerRef={refEmail}
                        id="addVendorEmail"
                        name="vendorEmail"
                        type="email"
                        autoComplete="email"
                        className={`form-control ${emailError ? 'is-invalid' : ''}`}
                        placeholder={t('vendorsEditor.placeholderEmail')}
                    />
                    {emailError ? <div className="invalid-feedback d-block">{emailError}</div> : null}
                </Form.Group>
            ) : (
                <Button
                    type="button"
                    variant="link"
                    className="p-0 text-primary"
                    onClick={() => setShowEmail(true)}
                >
                    {t('vendorsEditor.addEmail')}
                </Button>
            )}
        </Form>
    );
};

export default AddVendorForm;
